import { render } from "./component-jxjggl.vue?vue&type=template&id=4b1227df"
import script from "./component-jxjggl.vue?vue&type=script&lang=js"
export * from "./component-jxjggl.vue?vue&type=script&lang=js"

import "./component-jxjggl.vue?vue&type=style&index=0&id=4b1227df&lang=scss"

import exportComponent from "/Users/admin/Desktop/Project/jy-dashboard-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__